var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDuration3Selected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b7b6b6;}.cls-2{fill:#dcdcdc;}.cls-3{fill:#f1f1f1;}.cls-4{fill:#333;}.cls-5{fill:#ec6841;}.cls-6{fill:#fff;}.cls-7{fill:#af975c;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "duree3_selected",
    "data-name": "duree3 selected"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41,31A13.47,13.47,0,1,1,27.53,17.51,13.47,13.47,0,0,1,41,31"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.16,20.43a13.18,13.18,0,0,0-1.71,1.63l-1-1,1.67-1.67Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 14.48,
    y: 18.65,
    width: 4.4,
    height: 1.78,
    transform: "translate(-8.93 17.52) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.6,21.05l-1,1a13.9,13.9,0,0,0-1.72-1.63l1-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 37.46,
    y: 17.34,
    width: 1.78,
    height: 4.4,
    transform: "translate(-2.58 32.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.86,31a2.81,2.81,0,0,1,0,.29,9.89,9.89,0,0,1-.67,3.4c-.06.18-.14.35-.22.53A10,10,0,0,1,35,38.08c-.13.14-.26.27-.4.4a10,10,0,0,1-2.89,1.93,3.38,3.38,0,0,1-.52.22,9.9,9.9,0,0,1-3.41.67,1.27,1.27,0,0,1-.28,0,1.32,1.32,0,0,1-.28,0,9.9,9.9,0,0,1-3.41-.67l-.53-.22a10,10,0,0,1-2.88-1.93c-.14-.13-.27-.26-.4-.4A10,10,0,0,1,18.1,35.2a4,4,0,0,1-.22-.53,9.89,9.89,0,0,1-.67-3.4,1.42,1.42,0,0,1,0-.29,1.37,1.37,0,0,1,0-.28,10.13,10.13,0,0,1,.66-3.41c.07-.17.14-.35.22-.52A10.33,10.33,0,0,1,20,23.88c.13-.14.26-.27.4-.4a10,10,0,0,1,2.88-1.93l.53-.22a9.9,9.9,0,0,1,3.41-.67h.56a9.9,9.9,0,0,1,3.41.67,4.77,4.77,0,0,1,.52.22,10,10,0,0,1,2.89,1.93c.14.13.27.26.4.4A10.33,10.33,0,0,1,37,26.77l.22.52a10.13,10.13,0,0,1,.66,3.41,2.72,2.72,0,0,1,0,.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M25.33,16v1.72a14.41,14.41,0,0,1,2.2-.18,14.64,14.64,0,0,1,2.21.18V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.25,34.47c.09-.26.18-.53.25-.8a1.6,1.6,0,0,0,0-.21,5.43,5.43,0,0,0,.13-.58,4.51,4.51,0,0,0,.08-.53,2.17,2.17,0,0,0,0-.25c0-.35.06-.7.07-1.05,0,0,0,0,0-.06h0v0c0-.15,0-.31,0-.46s0-.31,0-.46l0-.31c0-.13,0-.26-.06-.38s0-.36-.09-.54,0-.12-.05-.19c0-.23-.11-.46-.18-.68a.19.19,0,0,1,0-.07c-.06-.19-.12-.38-.19-.57L37,26.77a.91.91,0,0,1-.07-.14l0-.05c0-.06-.06-.11-.08-.17l-.28-.53-.24-.4-.19-.29c-.14-.21-.28-.4-.43-.59l-.06-.08a10.4,10.4,0,0,0-.7-.79,3.85,3.85,0,0,0-.41-.4,10,10,0,0,0-2.67-1.75l-.07,0,0,0-.16-.07-.26-.11-.27-.1h0a9.73,9.73,0,0,0-3.21-.6h-.56L27.53,31h0l7.24,7.34c.14-.13.27-.26.4-.4A10,10,0,0,0,37,35.19h0c0-.08.06-.16.09-.23a2.4,2.4,0,0,0,.11-.23s0,0,0-.05v0l.06-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.35,16H24.71a3,3,0,1,1,0-6h5.64a3,3,0,1,1,0,6m-5.64-4.39a1.42,1.42,0,1,0,0,2.83h5.64a1.42,1.42,0,1,0,0-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.53,37.59A6.61,6.61,0,1,1,34.14,31a6.62,6.62,0,0,1-6.61,6.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.8,21.26v1.41h-.54V21.26h.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M27.8,39.3v1.4h-.54V39.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.59,23.2l-.49.2-.54-1.29a5.32,5.32,0,0,1,.5-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.5,39.86l-.5.2-.53-1.29.49-.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.84,24.91l-.38.38-1-1a4.4,4.4,0,0,1,.38-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.58,37.66a4.4,4.4,0,0,1-.37.38l-1-1,.38-.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20,27.56l-.21.49-1.3-.54.21-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.61,34.45a5.32,5.32,0,0,1-.21.5l-1.29-.54.21-.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.21,30.72v.53h-1.4a2.44,2.44,0,0,1,0-.27,2.26,2.26,0,0,1,0-.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M37.26,31a2.44,2.44,0,0,1,0,.27h-1.4v-.53h1.4a2.26,2.26,0,0,1,0,.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20,34.41,18.66,35c-.08-.17-.15-.33-.21-.49l1.29-.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M36.62,27.51l-1.3.54-.21-.49,1.3-.54.21.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.84,37.05l-1,1c-.13-.12-.26-.25-.38-.38l1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M34.58,24.3l-1,1-.38-.38,1-1a3.23,3.23,0,0,1,.37.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.59,38.77l-.53,1.29a5.32,5.32,0,0,1-.5-.21l.54-1.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.5,22.11,31,23.4l-.49-.2L31,21.9a5.32,5.32,0,0,1,.5.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M29.13,31.42l2.53,3.75L28,32.53a1.61,1.61,0,0,1-1.6-.44,1.64,1.64,0,0,1,2.35-2.29,1.67,1.67,0,0,1,.4,1.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M26.91,31.53a.86.86,0,1,0,0-1.21.85.85,0,0,0,0,1.21"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 55,
    height: 55
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDuration3Selected);
export default __webpack_public_path__ + "static/media/icon_duration_3_selected.5f785fe2349d2fe02a07c5a1ebd9b6cd.svg";
export { ForwardRef as ReactComponent };